// Auto-generated version file — DO NOT EDIT MANUALLY
// Generated at: 2026-04-15 14:16:14 UTC

const deployedVersion = {
  semantic_version: 'v0.1.6',
  full_version: 'prod-v0.1.6-20260415-1416-c5a355e1',
  version_prefix: '0.1',
  version_counter: 6,
  git_sha: 'c5a355e17f71718e5e0ffb2dd7b58418b744385e',
  short_sha: 'c5a355e1',
  timestamp: '20260415-1416',
  deployed_by: 'leopthurler',
  deployed_at: '2026-04-15 14:16:14 UTC',
  workflow_run: '24459645123',
  build_date: '2026-04-15T14:16:14Z',
}

const localVersion = {
  semantic_version: 'v0.0.0-dev',
  full_version: 'local-dev',
  version_prefix: '0.0',
  version_counter: 0,
  git_sha: 'local-development',
  short_sha: 'local',
  timestamp: '00000000-0000',
  deployed_by: 'local-developer',
  deployed_at: 'Not deployed',
  workflow_run: 'N/A',
  build_date: new Date().toISOString(),
}

export const version: {
  semantic_version: string
  full_version: string
  version_prefix: string
  version_counter: number
  git_sha: string
  short_sha: string
  timestamp: string
  deployed_by: string
  deployed_at: string
  workflow_run: string
  build_date: string
} = import.meta.env.DEV ? localVersion : deployedVersion

export type Version = typeof version
